var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgU27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 2,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-150",
    stroke: "#292929",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 1.5,
    y: 1.5,
    width: 57,
    height: 23.7312349,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64285714,15.3209895 L50.3571429,15.3209895 L50.3571429,57.5852718 C50.3571429,58.2480135 49.8198846,58.7852718 49.1571429,58.7852718 C48.905002,58.7852718 48.6592672,58.7058497 48.4548213,58.5582797 L41.4661609,53.5138331 C40.6974355,52.9589637 39.6597074,52.9589637 38.890982,53.5138331 L31.2875895,59.0019961 C30.5188641,59.5568656 29.4811359,59.5568656 28.7124105,59.0019961 L21.109018,53.5138331 C20.3402926,52.9589637 19.3025645,52.9589637 18.5338391,53.5138331 L11.5451787,58.5582797 C11.0078012,58.9461612 10.2577307,58.8249708 9.86984919,58.2875933 C9.72227924,58.0831474 9.64285714,57.8374126 9.64285714,57.5852718 L9.64285714,15.3209895 L9.64285714,15.3209895 Z",
    id: "\\u77E9\\u5F62",
    fill: "#2B6EFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(17.142857, 28.163265)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.42857143,
    y1: 0.612244898,
    x2: 25.8451418,
    y2: 0.612244898,
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.17397437e-13,
    y1: 0.612244898,
    x2: 1.20228467,
    y2: 0.612244898,
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.99766764e-14,
    y1: 11.6326531,
    x2: 25.8451418,
    y2: 11.6326531,
    id: "\\u8DEF\\u5F84"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 15.3061224,
    x2: 52.5,
    y2: 15.3061224,
    id: "\\u8DEF\\u5F84-228",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU27);
export default __webpack_public_path__ + "static/media/u27.d12368972b9e1be674ea9e0d9dc977e0.svg";
export { ForwardRef as ReactComponent };